export default __webpack_public_path__ + "static/media/icon-overview-active.14aa239a.svg";